import PendingPostApproveDelete from '@src/components/Post/PendingPostApproveDelete/PendingPostApproveDelete';
import { isPendingPost, isPostDeleted } from '@src/model/upvote/helpers';
import { canViewPendingContent } from '@src/model/upvote/permission';
import { PostStatus } from '@src/store/contentEntities/model';
import { usePost } from '@src/store/posts/hooks/usePost';
import { type FC, memo } from 'react';
import PostStatsAndReactions from '../PostStatsAndReactions/PostStatsAndReactions';
import PostContent from './PostContent';
import PostFlairs from './PostFlairs';
import { PostViewModScore } from './PostViewModScore';

interface PostViewDetailsProps {
    postId: string;
    tokenName: string;
    onExpand?: () => void;
}

const PostViewDetails: FC<PostViewDetailsProps> = ({ postId, tokenName, onExpand }) => {
    const post = usePost(postId);

    function renderPendingApproveOrDelete() {
        if (post?.status !== PostStatus.PENDING) return null;
        if (!canViewPendingContent(tokenName)) return null;

        return <PendingPostApproveDelete postId={postId} className="py-4" />;
    }

    function renderStatsAndReactions() {
        if (isPostDeleted(postId) || isPendingPost(postId)) return null;

        return (
            <div className="text-sm leading-none text-gray-500">
                <PostStatsAndReactions tokenName={tokenName} className="h-5 space-x-3" postId={postId} isDisabled={isPendingPost(postId)} />
            </div>
        );
    }

    return (
        <>
            <PostViewModScore postId={postId} tokenName={tokenName} />
            <PostContent onExpand={onExpand} postId={postId} tokenName={tokenName} enableExpend={true} />
            <PostFlairs postId={postId} tokenName={tokenName} />
            {renderPendingApproveOrDelete()}
            {renderStatsAndReactions()}
        </>
    );
};

export default memo(PostViewDetails);
